import { isUuid } from '@mkp/shared/models';

const UNKNOWN_SECTION = 'unknown';

const LOGIN_SEGMENTS = new Set(['login', 'passwordless-login', 'reset-password']);

const ONBOARDING_SEGMENTS = new Set([
  'onboarding',
  'verify-identity',
  'claim-company',
  'redeem-invite',
  'invalid-invite',
  'incomplete-onboarding',
]);

const ERROR_SEGMENTS = new Set(['unauthorized', 'forbidden', 'not-found', 'internal-error']);

const SECTION_MAP = new Map<string, string>([
  ...[...LOGIN_SEGMENTS].map((s) => [s, 'login'] as const),
  ...[...ONBOARDING_SEGMENTS].map((s) => [s, 'onboarding'] as const),
  ...[...ERROR_SEGMENTS].map((s) => [s, 'error'] as const),
]);

export const urlToPageSection = (url: string): string => {
  if (!url) return UNKNOWN_SECTION;

  const [path] = url.split('?');

  const firstSegment = path
    .split('/')
    .filter((s) => s !== '' && s !== 'workspace' && !isUuid(s))[0];

  if (!firstSegment) return UNKNOWN_SECTION;

  return SECTION_MAP.get(firstSegment) ?? firstSegment;
};
